import { FC, memo, useState } from 'react'
import { Button, Grid } from '@maas-components/core'
import {
  EVariationTypes,
  MAIN_VARIATION_TYPES_LIST,
  OTHER_VARIATION_TYPES_LIST,
} from 'core/common/constants/multivariation'
import i18n from 'core/common/i18n'
import CardStep from 'core/components/CardStep'
import SelectionButton from 'core/components/SelectionButton'
import OtherVariationsModal from './OtherVariationsModal'

type TVariationTypeProps = {
  onSubmit: (type: EVariationTypes) => void
  onSkip?: () => void
  disabledItems?: EVariationTypes[]
  title: string
  description?: string | React.ReactNode
  variationTypeSelected?: EVariationTypes | null
}

const VariationType: FC<TVariationTypeProps> = ({
  onSubmit,
  disabledItems = [],
  onSkip,
  title,
  description,
  variationTypeSelected,
}) => {
  const [openModal, setOpenModal] = useState(false)

  const handleSubmitOtherTypes = (variationType: EVariationTypes | null) => {
    if (!variationType) {
      return
    }

    setOpenModal(false)
    onSubmit(variationType)
  }

  return (
    <>
      <CardStep
        title={title}
        description={description}
        footerActions={
          onSkip && (
            <Button color="primary" onClick={onSkip} data-testid="skip-button">
              {i18n.t('general.skip')}
            </Button>
          )
        }
      >
        <Grid direction="row" spacing={2} container>
          {MAIN_VARIATION_TYPES_LIST.map(({ label, Icon, value }) => (
            <Grid xs={2} key={label} item>
              <SelectionButton
                label={label}
                Icon={Icon}
                disabled={disabledItems.includes(value)}
                onClick={() => onSubmit(value)}
                ariaLabel={label}
                selected={value === variationTypeSelected}
              />
            </Grid>
          ))}
          <Grid xs={2} item>
            <SelectionButton
              label={i18n.t('general.moreOptions')}
              onClick={() => setOpenModal(true)}
              ariaLabel={i18n.t('general.moreOptions')}
              selected={OTHER_VARIATION_TYPES_LIST.some(
                ({ value }) => value === variationTypeSelected
              )}
            />
          </Grid>
        </Grid>
      </CardStep>
      <OtherVariationsModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onSubmit={handleSubmitOtherTypes}
      />
    </>
  )
}

export default memo(VariationType)
